import { Button } from "@sellar-io/components";
import { ReactNode, useEffect, useState } from "react";
import { useShallow } from "zustand/shallow";
// import dayjs from "dayjs";
import { useDiscoveryV2PreOrderStore } from "../DiscoveryV2PreOrderStore";
import { useDiscoveryPreOrdersMonths } from "../../../../hooks/api/v2/discovery/useDiscoveryPreOrdersMonths";
// import {
//   Dropdown,
//   DropdownButtonSlim,
//   DropdownItem,
//   DropdownItems,
// } from "../../../../components/dropdown/Dropdown";
// import { Icon, SpinnerLegacy } from "../../../../components";
import { SpinnerLegacy } from "../../../../components";

type MenuItemType = {
  content: ReactNode;
  onClick?: () => void;
  key: string;
  subItems?: MenuItemType[];
};

export const DiscoveryPreOrderFilterBar = () => {
  const [selected, setSelected] = useState<number | undefined>();

  const {
    // setMonthSelected,
    toggleContainer,
    setMonths,
    // monthSelected,
    // months,
    containerTypes,
  } = useDiscoveryV2PreOrderStore(
    useShallow((state) => ({
      monthSelected: state.selectedMonth,
      months: state.months,
      setMonths: state.setMonths,
      setMonthSelected: state.setSelectedMonth,
      toggleContainer: state.toggleContainerType,
      clearContainerTypes: state.clearContainerTypes,
      categoryKey: state.selectedCategoryType,
      containerTypes: state.selectedContainerTypes,
    })),
  );

  const monthsQuery = useDiscoveryPreOrdersMonths({});

  const menuItems: MenuItemType[] = [
    { content: "Keg", key: "keg", onClick: () => toggleContainer("keg") },
    { content: "Cask", key: "cask", onClick: () => toggleContainer("cask") },
    { content: "Can", key: "can", onClick: () => toggleContainer("can") },
    {
      content: "Bottle",
      key: "bottle",
      onClick: () => toggleContainer("bottle"),
    },
    {
      content: "Bag In Box",
      key: "bagInBox",
      onClick: () => toggleContainer("bagInBox"),
    },
  ];

  useEffect(() => {
    if (monthsQuery.data?.length) {
      setMonths(monthsQuery.data);
    }
  }, [monthsQuery.data, setMonths]);

  const { isPending } = monthsQuery;
  if (isPending) {
    return <SpinnerLegacy />;
  }

  return (
    <div className="flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex items-center gap-2 overflow-x-auto pb-1 lg:pb-0">
        {menuItems.map((menuItem, idx) => (
          <MenuItem
            key={idx}
            onClick={() => {
              setSelected(idx === selected ? undefined : idx);
              menuItem.onClick?.();
            }}
            selected={containerTypes.includes(menuItem.key)}
            containerType={menuItem.key}
          >
            {menuItem.content}
          </MenuItem>
        ))}
      </div>
      {/* TODO: debug issues in prod and bring this back */}
      {/* <div className="flex items-center gap-1">
        <div className="md:w-aut w-full">
          <Dropdown>
            <DropdownButtonSlim>
              <>
                <Icon
                  icon={"CALENDAR_BLANK_OUTLINE"}
                  size={0.8}
                  className="text-black"
                />
                {monthSelected
                  ? dayjs(monthSelected).format("MMMM YYYY")
                  : "Release date"}
                <Icon icon={"CHEVRON_DOWN"} size={0.8} className="text-black" />
              </>
            </DropdownButtonSlim>
            <DropdownItems>
              <DropdownItem key={"all"} onClick={() => setMonthSelected(null)}>
                All
              </DropdownItem>
              {months.length &&
                months.map((month) => (
                  <DropdownItem
                    key={month.toString()}
                    onClick={() => setMonthSelected(month)}
                  >
                    {dayjs(month).format("MMMM YYYY")}
                  </DropdownItem>
                ))}
            </DropdownItems>
          </Dropdown>
        </div>
      </div> */}
    </div>
  );
};

const MenuItem = ({
  children,
  onClick,
  containerType,
  selected,
}: {
  children: ReactNode;
  onClick: () => void;
  containerType: string;
  selected: boolean;
}) => {
  return (
    <Button
      color="slim"
      size="small"
      key={containerType}
      onClick={onClick}
      selected={selected}
      aria-pressed={selected}
      className="shrink-0 capitalize shadow-xs"
      aria-label={`Filter by ${containerType}`}
    >
      {children}
    </Button>
  );
};
